module.exports = __WEBPACK_EXTERNAL_MODULE_1168__;


//////////////////
// WEBPACK FOOTER
// external "History"
// module id = 1168
// module chunks = 1